export const environment = {
  production: false,
  // Demo/offline mode: when true, list endpoints return flag-gated MOCK data
  // (core/mock-data.ts) so the UI renders realistic states with no backend. For
  // design review / demo only — default false; never true in prod.
  // Flip to true locally (uncommitted) to build the populated design-review artifact.
  useMockData: false,
  apiBaseUrl: 'https://supportapi-dev.bluetitan.ai',
  // BT Sidekick assistant config. IMPORTANT: brainBaseUrl is bluetitan-api's base --
  // a DIFFERENT host than apiBaseUrl above (the bluetitan-support ticket service).
  // The loader mints a bundle URL from `${brainBaseUrl}/assistant/bundle-url` and
  // the mounted element chats against the same base. brainBaseUrl MUST include the
  // /api/v1 segment: bluetitan-api mounts its app under /api/v1 (root_path), so
  // without it the mint 404s. Mirrors ui2, whose brainBaseUrl is also the /api/v1 base.
  assistant: {
    brainBaseUrl: 'https://devapi.bluetitan.ai/api/v1',
    bundleChannel: 'dev',
  },
  // support.queues.id for the seeded 'l1-access' queue (db/alembic_btsupport
  // 002_seed_queues_and_sla_policies) — a deploy-time value, not derivable
  // client-side (no public key->id lookup exists yet). Fill in from the dev
  // org's seeded row.
  intakeQueueId: 'a6ca231f-7ff0-43d6-bfee-95cbed6ed84c',
  auth: {
    clientId: 'c145accc-75c8-4e7b-b0e6-a9c6f9c53dea',
    authority: 'https://login.microsoftonline.com/89c5df46-04c0-41e5-bb81-f41116dfa13a',
    // MSAL redirects the login response here; only CallbackComponent (/callback)
    // calls handleRedirectPromise() to process it. Points at the bound custom domain
    // support-dev.bluetitan.ai (validated on the SWA bt-swa-support-console-dev-01);
    // the SWA default host victorious-bay-…azurestaticapps.net/callback stays
    // registered on the app registration as a fallback.
    redirectUri: 'https://support-dev.bluetitan.ai/callback',
    postLogoutRedirectUri: 'https://support-dev.bluetitan.ai',
    cacheLocation: 'sessionStorage' as const,
    logLevel: 'Warning' as const,
    piiLoggingEnabled: false,
    apiScope: 'api://c145accc-75c8-4e7b-b0e6-a9c6f9c53dea/access_as_agent',
  },
  // Partner (VAR) rail — CIAM tenant 05ec6ebe. A SECOND MSAL app registration
  // "BlueTitan Support Console - Partner (VAR)" (SPA, appId a1affc88). VARs live in
  // the CIAM tenant, not the workforce tenant above, so they need their own instance.
  // authority MUST be a CIAM host — the login-dev.bluetitan.ai custom URL domain
  // (AB#2251), or <tenant>.ciamlogin.com — NOT login.microsoftonline.com; getting it
  // wrong fails login silently. Tokens issued through the custom domain still carry
  // iss https://<tenant>.ciamlogin.com/<tenant>/v2.0, which is what bluetitan-shared
  // bt_token.py ciam_provider validates, so the API side does not change with the host.
  // apiScope's user_impersonation on 3dce455e (BlueTitan Support API) mints an access
  // token whose aud == the API's BT_SUPPORT_AUTH_AUDIENCE.
  // redirectUri targets the bound custom domain support-dev.bluetitan.ai; the a1affc88
  // reg also registers the SWA default host + localhost:8443 + g913.local:8443 /callback
  // URIs for fallback/local/appliance serving.
  // `null` = partner rail unavailable in this environment (see environment.prod.ts).
  ciamAuth: {
    clientId: 'a1affc88-88c4-4c4a-888b-3a23c749cbef',
    authority: 'https://login-dev.bluetitan.ai/05ec6ebe-be40-40c0-aa1a-197abd2150b4',
    knownAuthority: 'login-dev.bluetitan.ai',
    apiScope: 'api://3dce455e-70e3-415b-ae62-faec36a58d95/user_impersonation',
    redirectUri: 'https://support-dev.bluetitan.ai/callback',
  },
};
